export default __webpack_public_path__ + "images/4cec7c2818538f77f591fbd621ac1563.png";